import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "unitPricingList",
    "bidAlternatesList",
    "damagesAmount",
    "emailNotifTiming",
    "submitBtn"
  ]

  connect() {
    const form = this.element.querySelector("form")
    if (form) {
      form.setAttribute("novalidate", "")
      form.addEventListener("submit", (e) => this._validateAndSubmit(e))
    }
  }

  unitPricingChanged(event) {
    this.unitPricingListTarget.classList.toggle("hidden", event.target.value !== "yes_list")
  }

  bidAlternatesChanged(event) {
    this.bidAlternatesListTarget.classList.toggle("hidden", event.target.value !== "yes_list")
  }

  damagesChanged(event) {
    const show = event.target.value === "1" || event.target.value === "true"
    this.damagesAmountTarget.classList.toggle("hidden", !show)
  }

  emailNotifChanged(event) {
    this.emailNotifTimingTarget.classList.toggle("hidden", !event.target.checked)
  }

  _validateAndSubmit(event) {
    // Clear previous errors
    this.element.querySelectorAll(".border-red-400").forEach(el => {
      el.classList.remove("border-red-400", "ring-1", "ring-red-400")
    })
    this.element.querySelectorAll("[data-field-error]").forEach(el => el.classList.add("hidden"))

    const errors = []
    const requiredSelects = this.element.querySelectorAll("select[data-required]")

    requiredSelects.forEach(select => {
      if (!select.value) {
        select.classList.add("border-red-400", "ring-1", "ring-red-400")
        const errorSpan = select.closest("div").querySelector("[data-field-error]")
        if (errorSpan) errorSpan.classList.remove("hidden")
        errors.push(select)
      }
    })

    if (errors.length > 0) {
      event.preventDefault()
      errors[0].scrollIntoView({ behavior: "smooth", block: "center" })
      return
    }

    this._disableSubmit()
  }

  clearFieldError(event) {
    const field = event.currentTarget
    if (field.value) {
      field.classList.remove("border-red-400", "ring-1", "ring-red-400")
      const errorSpan = field.closest("div").querySelector("[data-field-error]")
      if (errorSpan) errorSpan.classList.add("hidden")
    }
  }

  _disableSubmit() {
    const btn = this.submitBtnTarget
    btn.disabled = true
    btn.innerHTML = `<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>Saving...`
    btn.classList.add("opacity-75", "cursor-not-allowed")
  }
}
